import { useCallback } from 'react';
import { IconButton } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBoxTwoTone';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlankTwoTone';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { CellProps } from '@components/DataGrid/types';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';

import styles from '../../RenderCell.module.css';

/**
 * Rail Billing Cell Rendered Component for the Dispatch Board
 */
export default function RailBillingCell({ row }: CellProps<DispatchLeg>) {
	const appDispatch = useAppDispatch();

	const handleCheckboxClick = useCallback(() => {
		appDispatch(
			queueModal({
				Component: 'railBillingModal',
				Props: {
					consignmentId: row.csnId,
					dispatchLeg: row
				}
			})
		);
	}, [appDispatch, row]);

	const showCheckbox = row.jobCategoryTransportationType === 'Export' ? row.isFirstFCL : row.isLastECL;
	if (!showCheckbox) return <></>;

	return (
		<IconButton
			className={styles['rail-bill-col-ico']}
			onClick={handleCheckboxClick}
		>
			{row.isRailBilled ? <CheckBoxIcon titleAccess='Rail Billed' /> : <CheckBoxOutlineBlankIcon titleAccess='Rail Billed' />}
		</IconButton>
	);
}
